import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getTrackComplaintsList,
  getDetailedTrackComplaint,
  fetchSeverityTypes,
  complaintAssign,
} from '../services';

import {
  API_STATUS,
  blankDetailedComplaint,
  BlankPagination,
  DEFAULT_OPTION,
} from '../utils/Constant';
import { isAPISuccess } from '../utils/Util';
import {
  EmployeeNameType,
  SelectOptionType,
  TrackComplaintsInitialState,
} from '../utils/Types';
import { getEmployeeDrop, getStatusDrop } from '../services/dropDownService';
export const trackComplaintsInitialState = {
  trackComplaintsData: {
    status: '',
    pagination: BlankPagination,
    result: [],
  },
  detailedComplaintData: {
    status: '',
    result: blankDetailedComplaint,
  },
  severityOptions: [DEFAULT_OPTION],
  statusOptions: [DEFAULT_OPTION],
  employeeList: [],
  employeeNameOptions: [],
};

const initialState: TrackComplaintsInitialState = trackComplaintsInitialState;

export const getComplaintsList = createAsyncThunk(
  'trackComplaints/getComplaintsList',
  async (data: any) => {
    const res = await getTrackComplaintsList(data);
    return res.data;
  }
);

export const getDetailedComplaint = createAsyncThunk(
  'trackComplaints/getDetailedComplaint',
  async (dataParam: any) => {
    const res = await getDetailedTrackComplaint(dataParam);
    return res.data;
  }
);

export const getStatusDrops = createAsyncThunk(
  'trackComplaints/getStatusDrops',
  async (params: any) => {
    const res = await getStatusDrop(params);
    return res.data;
  }
);

export const getSeverityTypes = createAsyncThunk(
  'trackComplaints/getSeverityTypes',
  async () => {
    const res = await fetchSeverityTypes();
    return res.data;
  }
);

export const getEmployeeList = createAsyncThunk(
  'trackComplaints/employeeList',
  async () => {
    const res = await getEmployeeDrop();
    return res.data;
  }
);

export const assignTheEmployee = createAsyncThunk(
  'trackComplaints/assignEmployee',
  async (data: any) => {
    const res = await complaintAssign(data);
    return res.data;
  }
);
export const trackComplaintsSlice = createSlice({
  name: 'trackComplaints',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getComplaintsList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.trackComplaintsData.status = API_STATUS.SUCCEEDED;
          state.trackComplaintsData.pagination = action.payload.pagination;
          state.trackComplaintsData.result = action.payload.result;
        } else {
          state.trackComplaintsData.result = [];
          state.trackComplaintsData.pagination = BlankPagination;
        }
      })
      .addCase(getDetailedComplaint.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.detailedComplaintData.status = API_STATUS.SUCCEEDED;
          state.detailedComplaintData.result = action.payload.result;
        } else {
          state.detailedComplaintData.status = '';
          state.detailedComplaintData.result = blankDetailedComplaint;
        }
      })
      .addCase(getStatusDrops.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          const dropdowns = action.payload.result?.map((item: any) => ({
            value: item.statusId,
            label: item.statusName,
          }));
          state.statusOptions = dropdowns;
        }
      })
      .addCase(getSeverityTypes.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          const result = action.payload.result;
          if (result && result.length > 0) {
            const selectOptions: SelectOptionType[] = [];
            result.forEach(
              (element: { severityId: number; severityName: string }) => {
                selectOptions.push({
                  value: element.severityId,
                  label: element.severityName,
                });
              }
            );
            state.severityOptions = selectOptions;
          }
        }
      })
      .addCase(getEmployeeList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.employeeList = action.payload.result;
          const empList = action.payload.result;
          const names: SelectOptionType[] = [];
          empList?.forEach((item: EmployeeNameType) => {
            names.push({
              label: `${item?.employeeName} (${item?.employeeUniqueId ?? ''})`,
              value: item?.candidateId,
            });
          });
          state.employeeNameOptions = names;
        } else {
          state.employeeList = [];
        }
      });
  },
});

export const trackComplaintsSelector = (state: {
  trackComplaints: TrackComplaintsInitialState;
}) => state.trackComplaints;

export default trackComplaintsSlice.reducer;
